import Application from '@ember/application';
import EngineRouterService from '../services/engine-router-service.js';
import Engine from '@ember/engine';
import '@ember/service';
import '@ember/debug';
import '@ember/object';
import '@ember/object/computed';
import '@ember/object/evented';
import '../utils/namespace-engine-route-name.js';
import '../utils/root-owner.js';
import '@ember/application/instance';
import '../utils/resembles-url.js';

Engine.reopen({
  buildRegistry() {
    let registry = this._super(...arguments);

    if (!(this instanceof Application)) {
      registry.register('service:router', EngineRouterService);
    }

    return registry;
  }

});

// Load extensions to Ember

function initialize() {}
var emberEnginesRouterService = {
  name: 'ember-engines-router-service',
  initialize
};

export { emberEnginesRouterService as default, initialize };
